<template>
<ats
  v-bind="$props"
  service="workday"
  :savingConf="savingConf"
  :credential="{ handler: '', username: '', password: '', wsdl: '', wsdl_extra: '', source_id: '', refresh_token_url: '', refresh_token: '' }"
  :cached="true"
  :multiai="true"
  @input="onInput">
  <template v-slot:credential="{ credential }">
    <div>
      <label for="handler">Handler</label>
      <input v-model="credential.handler" id="handler" name="handler"/>
      <modified :enable="value.credential && value.credential.handler !== credential.handler"/>
    </div>
    <div>
      <label for="username">Username</label>
      <input v-model="credential.username" id="username" name="username"/>
      <modified :enable="value.credential && value.credential.username !== credential.username"/>
    </div>
    <div>
      <label for="password">Password</label>
      <input v-model="credential.password" id="password" name="password"/>
      <modified :enable="value.credential && value.credential.password !== credential.password"/>
    </div>
    <div>
      <label for="wsdl">WSDL</label>
      <input v-model="credential.wsdl" id="wsdl" name="wsdl"/>
      <modified :enable="value.credential && value.credential.wsdl !== credential.wsdl"/>
    </div>
    <div>
      <label for="wsdl_extra">WSDL extra</label>
      <input v-model="credential.wsdl_extra" id="wsdl_extra" name="wsdl_extra"/>
      <modified :enable="value.credential && value.credential.wsdl_extra !== credential.wsdl_extra"/>
    </div>
    <div>
      <label for="refresh_token">Refresh Token</label>
      <input v-model="credential.refresh_token" id="refresh_token" name="refresh_token"/>
      <modified :enable="value.credential && value.credential.refresh_token !== credential.refresh_token"/>
    </div>
    <div>
      <label for="refresh_token_url">Refresh Token Url</label>
      <input v-model="credential.refresh_token_url" id="refresh_token_url" name="refresh_token_url"/>
      <modified :enable="value.credential && value.credential.refresh_token_url !== credential.refresh_token_url"/>
    </div>
    <div>
      <label for="source_id">Source ID</label>
      <input v-model="credential.source_id" id="source_id" name="source_id"/>
      <modified :enable="value.credential && value.credential.source_id !== credential.source_id"/>
    </div>
  </template>
</ats>
</template>

<script>
import Ats from './sdk-v3'
import Recruiter from '/user/recruiter/recruiter.entity'
import Search from '/requirement/entity'
import Modified from '/ats/modified'

export default {
  name: 'hippolyte.services.workday.config',
  components: { Ats, Modified },
  props: {
    value: Object,
    recruiter: Recruiter,
    search: Search,
    savingConf: Boolean
  },
  methods: {
    onInput (event) {
      this.$emit('input', event)
    }
  }
}
</script>
